import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OnyxEvent } from '../models/event';
import { PartyType } from '../models/party-type';

@Component({
  selector: 'pioneer-child-contact-form',
  templateUrl: './child-contact-form.component.html'
})
export class ChildContactFormComponent implements OnInit {

  @Input('partyType')
  public partyType: PartyType;

  @Input('contactReferenceNumberTitle')
  public contactReferenceNumberTitle: String;

  @Input('contactForm')
  public contactForm: FormGroup;

  public onyxEvent: OnyxEvent;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input()
  public isReadOnly = true;

  constructor() {
  }

  public ngOnInit() {

  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/child-contact-form/child-contact-form.component.ts